
    import I18n from 'i18nObj';
    
      import 'translations/jquery_doc_previews';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('jquery_doc_previews');
  